import { Component, inject, signal } from '@angular/core';
import { Web3ErrorEntry, Web3ErrorService } from '../../services/web3-error.service';

@Component({
  selector: 'app-web3-error-toast',
  templateUrl: './web3-error-toast.component.html',
  styleUrls: [
    './web3-error-toast.component.css',
    './web3-error-toast.component.mobile.css',
  ],
})
export class Web3ErrorToastComponent {
  private service = inject(Web3ErrorService);

  readonly errors = this.service.errors;
  readonly copiedId = signal<number | null>(null);

  dismiss(id: number): void {
    this.service.dismiss(id);
  }

  async copy(entry: Web3ErrorEntry): Promise<void> {
    try {
      await navigator.clipboard.writeText(entry.message);
      this.copiedId.set(entry.id);
      setTimeout(() => {
        if (this.copiedId() === entry.id) this.copiedId.set(null);
      }, 1200);
    } catch {
      // clipboard denied — leave the toast as-is so the user can long-press
    }
  }

  isCopied(id: number): boolean {
    return this.copiedId() === id;
  }
}
